import React from "react";
import { Card, Col, Container, Nav, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { MdCoPresent } from "react-icons/md";
import { FaChartBar, FaListAlt, FaClipboardList, FaCalendarAlt } from "react-icons/fa";
import "../assets/styles/index.css";

const iconStyles = {
  faceAuth: { color: "#f4d033" }, // Yellow
  attendanceReports: { color: "#33a1ff" }, // Blue
  dailyAttendance: { color: "#28a745" }, // Green
  staffAttendance: { color: "#dc3545" }, // Red
  monthlyAttendance: { color: "#6f42c1" }, // Purple
};

const AttendanceScreen = () => {
  const menuItems = [
    {
      id: 1,
      title: "In & Out Entry",
      description: "Record your daily attendance and manage check-in/check-out times",
      icon: <MdCoPresent size={50} style={iconStyles.faceAuth} />,
      link: "/face-auth",
    },
    {
      id: 2,
      title: "Attendance Reports",
      description: "View and analyze your attendance history and reports",
      icon: <FaChartBar size={50} style={iconStyles.attendanceReports} />,
      link: "/attendance-reports",
    },
    {
      id: 3,
      title: "Daily Attendance List",
      description: "View daily attendance list with indoor and outdoor entries",
      icon: <FaListAlt size={50} style={iconStyles.dailyAttendance} />,
      link: "/staff-daily-attendance",
    },
    {
      id: 4,
      title: "Staff Attendance List",
      description: "Review and manage staff attendance with status tracking",
      icon: <FaClipboardList size={50} style={iconStyles.staffAttendance} />,
      link: "/staff-attendance-list",
    },
    {
      id: 5,
      title: "Monthly Attendance",
      description: "View and manage monthly attendance records",
      icon: <FaCalendarAlt size={50} style={iconStyles.monthlyAttendance} />,
      link: "/staff-monthly-attendance",
    },
  ];

  return (
    <Container className="py-5">
      <h2 className="text-center mb-5">Attendance Management</h2>
      <Row className="justify-content-center g-4">
        {menuItems.map((item) => (
          <Col key={item.id} xs={12} sm={10} md={6} lg={5} xl={4}>
            <Nav.Link as={Link} to={item.link} className="text-decoration-none h-100">
              <Card className="dashboard-card h-100 shadow-sm hover-card">
                <Card.Body className="d-flex flex-column align-items-center text-center p-4">
                  <div className="icon-wrapper mb-4">
                    {item.icon}
                  </div>
                  <Card.Title className="h4 mb-3">{item.title}</Card.Title>
                  <Card.Text className="text-muted mb-4">
                    {item.description}
                  </Card.Text>
                  <div className="mt-auto">
                    <div className="btn btn-outline-primary px-4">
                      Access
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Nav.Link>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default AttendanceScreen; 